export const buildVenuePath = (path, venueId) => {
  if (!venueId) return path;
  const hashIndex = path.indexOf('#');
  const hash = hashIndex >= 0 ? path.slice(hashIndex) : '';
  const target = hashIndex >= 0 ? path.slice(0, hashIndex) : path;
  const queryIndex = target.indexOf('?');
  const pathname = queryIndex >= 0 ? target.slice(0, queryIndex) : target;
  const params = new URLSearchParams(queryIndex >= 0 ? target.slice(queryIndex + 1) : '');
  params.delete('venue');
  params.delete('venueId');
  params.set('venue_id', venueId);
  return `${pathname}?${params.toString()}${hash}`;
};
